// extracted by mini-css-extract-plugin
export var breadcrumb = "_1b-0";
export var breadcrumbArrow = "_1b-1";